import { Page } from 'layouts/Page';
import { FC } from 'react';
import { VATReportDownloadContainer } from 'components/VATReportDownloadContainer';
import { IS_NEMAN } from '../../services/constants/env';

export const VATReportDownloadPage: FC = () => {
	return (
		<Page title={`VAT Report – ${IS_NEMAN ? ' Neman IOSS' : 'EAS'} Control Center`}>
			<VATReportDownloadContainer />
		</Page>
	);
};
